<script lang="ts">
import Decimal from 'decimal.js';
import { useFilterStub } from './filter-stub';
import { LocalFilterModel } from './FilterDecimal.vue';
</script>

<script setup lang="ts">
defineExpose(
  useFilterStub<string, LocalFilterModel>(
    {
      filter: '',
      type: 'equals',
    },
    ({ filter }) => filter.trim() !== '',
    ({ filter, type }, value) => {
      if (value == null) return false;
      const dFilter = new Decimal(filter.trim() || '0');
      const dValue = new Decimal(String(value).trim() || '0');
      switch (type) {
        case 'equals':
          return dValue.eq(dFilter);
        case 'greaterThan':
          return dValue.gt(dFilter);
        case 'greaterThanOrEqual':
          return dValue.gte(dFilter);
        case 'lessThan':
          return dValue.lt(dFilter);
        case 'lessThanOrEqual':
          return dValue.lte(dFilter);
      }
    }
  )
);
</script>

<!-- eslint-disable-next-line vue/valid-template-root -->
<template></template>
